import * as sentry from '../../src/utils/sentry'
import { Plat_isAndroid } from './Plat.device'

export async function Plat_savePathForRecovery(path: string): Promise<void> {
    if (!Plat_isAndroid()) return
    await window.plugins.androidRecovery.save('path', path)
}

export async function Plat_recoverPath(): Promise<string> {
    if (!Plat_isAndroid()) return null
    return window.plugins.androidRecovery.recover('path')
}

/**
 * If Android kills the app whilst it was waiting for a response from another activity
 * we want to recover the value of the reponse from the resume event
 * https://cordova.apache.org/docs/en/10.x/guide/platforms/android/#what-makes-android-different
 */
let recoveryValue: unknown = null

export function Plat_getRecoveryValue() {
    return recoveryValue
}

export function Plat_clearRecoveryValue() {
    recoveryValue = null
}

export async function Plat_saveRecoveryValue(result: CordovaResumeResult) {
    if (result?.pluginStatus === 'Error') {
        sentry.err(result.result, { extra: result })
    }

    if (result?.pluginStatus === 'OK') {
        recoveryValue = result.result
    }
}
